/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConfirmCaptureMediaRequest
 */
export interface ConfirmCaptureMediaRequest {
    /**
     * 
     */
    captureId: string;
    /**
     * 
     */
    s3Key: string;
    /**
     * 
     */
    filename?: string | null;
    /**
     * 
     */
    contentType?: string | null;
}

/**
 * Check if a given object implements the ConfirmCaptureMediaRequest interface.
 */
export function instanceOfConfirmCaptureMediaRequest(value: object): value is ConfirmCaptureMediaRequest {
    if ((!('captureId' in (value as Record<string, any>)) && !('capture_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['captureId'] === undefined && (value as Record<string, any>)['capture_id'] === undefined)) return false;
    if ((!('s3Key' in (value as Record<string, any>)) && !('s3_key' in (value as Record<string, any>))) || ((value as Record<string, any>)['s3Key'] === undefined && (value as Record<string, any>)['s3_key'] === undefined)) return false;
    return true;
}

export function ConfirmCaptureMediaRequestFromJSON(json: any): ConfirmCaptureMediaRequest {
    return ConfirmCaptureMediaRequestFromJSONTyped(json, false);
}

export function ConfirmCaptureMediaRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfirmCaptureMediaRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'captureId': json['capture_id'],
        's3Key': json['s3_key'],
        'filename': json['filename'] === undefined ? undefined : json['filename'] === null ? null : json['filename'],
        'contentType': json['content_type'] === undefined ? undefined : json['content_type'] === null ? null : json['content_type'],
    };
}

export function ConfirmCaptureMediaRequestToJSON(json: any): ConfirmCaptureMediaRequest {
    return ConfirmCaptureMediaRequestToJSONTyped(json, false);
}

export function ConfirmCaptureMediaRequestToJSONTyped(value?: ConfirmCaptureMediaRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'capture_id': value['captureId'],
        's3_key': value['s3Key'],
        'filename': value['filename'],
        'content_type': value['contentType'],
    };
}

